export const courseDetailGuest = () => ({
  value: undefined,
  loading: false,
  error: {
    id: undefined,
    message: undefined,
  },

  checked(value) {
    return this.value === value;
  },

  onSelect(value) {
    this.value = value;
  },

  async onSubmit(event: Event) {
    event.preventDefault();

    if (this.loading || !(this.$el as HTMLFormElement).checkValidity()) return;

    this.loading = true;

    const BASE_URL = document
      .querySelector('[data-api-url]')
      ?.getAttribute('data-api-url');

    if (!BASE_URL) {
      console.error('[courseDetailGuest] missing data-api-url attribute');
      return;
    }

    const form = this.$el as HTMLFormElement;
    const getFormInput = (name: string) =>
      form.querySelector(`input[name="${name}"]`) as HTMLInputElement;

    const firstName = getFormInput('firstName')?.value;
    const lastName = getFormInput('lastName')?.value;
    const email = getFormInput('email')?.value;
    const acceptConditions = getFormInput('acceptConditions')?.checked;
    const advertisingConsent = getFormInput('advertisingConsent')?.checked;

    await fetch(`${BASE_URL}guest/purchases/`, {
      method: 'POST',
      body: JSON.stringify({
        formatUid: this.value,
        firstName,
        lastName,
        email,
        acceptConditions,
        advertisingConsent,
      }),
    })
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          throw new TYPO3FetchError(res.status, data);
        }

        const confirmationUrl = document
          .querySelector('[data-confirmation]')
          ?.getAttribute('data-confirmation');

        if (!confirmationUrl) {
          console.error(
            '[courseDetailGuest] missing data-confirmation attribute'
          );
          this.loading = false;
          return;
        }

        window.location.href = confirmationUrl.replace('XXXX', this.value);
      })
      .catch((err) => {
        if (err.status === 500) {
          if (err.data?.id) {
            this.error.id = err.data.id;
          }
          switch (err.data.type) {
            case 'ALREADY_PURCHASED':
              this.error.message = 'Produkt wurde bereits gekauft.';
              break;
            case 'SOLD_OUT':
              this.error.message = 'Produkt ist ausverkauft.';
              break;
            case 'INVALID_FORMAT':
              this.error.message = 'Ungültiges Format.';
              break;
            case 'INTERNAL_ERROR':
              this.error.message =
                'Interner Fehler. Bitte versuchen Sie es erneut.';
              break;
          }
        } else {
          const invalidFields = (
            (err.data?.message?.split(',') || []) as string[]
          )
            .map((field) => `<b>${errorMap[field]}</b>`)
            .join(', ');
          if (invalidFields.length) {
            this.error.message = `Bitte überprüfe die Eingaben in den folgenden Feldern: ${invalidFields}.`;
          } else {
            this.error.message = 'Unbekannter Fehler';
          }
        }
        this.loading = false;
      });
  },
});

const errorMap: Record<string, string> = {
  email: 'E-Mail',
  firstName: 'Vorname',
  formatUid: 'Ungültiges Format',
  lastName: 'Nachname',
};

class TYPO3FetchError<T> extends Error {
  status: number;
  data?: {
    type?: string;
    message?: string;
  };

  constructor(status: number, data: T) {
    super();
    this.name = this.constructor.name;
    this.status = status;
    this.data = data;
  }
}
